package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import io.ktor.http.*
import se.mittpass.shared.api.*

class ComplianceRepository(private val httpClient: HttpClient) {
    suspend fun getWarnings(workplaceId: Long): Result<List<ComplianceWarningDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/compliance").body()
    }

    suspend fun runCheck(workplaceId: Long): Result<List<ComplianceWarningDto>> = runCatching {
        httpClient.post("workplaces/$workplaceId/compliance/check").body()
    }

    suspend fun acknowledge(warningId: Long): Result<Unit> = runCatching {
        httpClient.put("compliance/$warningId/acknowledge")
    }
}
